<template>
  <v-app id="app">
    <v-main>
      <router-view />
    </v-main>
  </v-app>
  <metainfo>
  </metainfo>
  <vue-cookie-accept-decline :debug="false" :disableDecline="false" :showPostponeButton="false"
    @clicked-accept="cookieClickedAccept" @clicked-decline="cookieClickedDecline"
    @clicked-postpone="cookieClickedPostpone" @removed-cookie="cookieRemovedCookie" @status="cookieStatus"
    elementId="cookies_modal" position="bottom-left" ref="myPanel1" transitionName="slideFromBottom" type="floating">
    <!-- Optional -->
    <template #postponeContent>&times;</template>

    <!-- Optional -->
    <template #message>
      <p class="cookies_modal_title mb-0">We use cookies </p>
      <p class="cookies_modal_subtitle mb-0">We use Google Analytics to analyze website traffic </p>
    </template>

    <!-- Optional -->
    <template #acceptContent>ACCEPT</template>

    <!-- Optional -->
    <template #declineContent>DECLINE </template>
  </vue-cookie-accept-decline>
</template>

<script>
import { useMeta } from 'vue-meta'

export default {
  name: 'App',
  setup() {
    useMeta({
      htmlAttrs: {
        lang: 'en',
      },
      title: "Work-o",
      description: "www",
      meta: [
        { vmid: 'description', name: 'description', content: "www" }
      ]
    })
  },
  data: () => ({
    //
  }),
  mounted() {
  },
  methods: {
    cookieStatus(status) {
      this.status = status;
    },
    cookieClickedAccept() {
      console.log('here in accept');
      this.status = 'accept';
    },
    cookieClickedDecline() {
      console.log('here in decline');
      this.status = 'decline';
    },
    cookieClickedPostpone() {
      console.log('here in postpone');
      this.status = 'postpone';
    },
    cookieRemovedCookie() {
      console.log('here in cookieRemoved');
      this.status = null;
      this.$refs.myPanel1.init();
    },
    removeCookie() {
      console.log('Cookie removed');
      this.$refs.myPanel1.removeCookie();
    },
  }
}
</script>
<style>
@import url("vue-cookie-accept-decline/dist/vue-cookie-accept-decline.css");

#cookies_modal .cookie__floating__content {
  margin-bottom: 0px;
}

#cookies_modal .cookie__floating__buttons__button--decline {
  background: transparent !important;
  color: #3d3d3d;
  border: unset;
  font-weight: 400;
  transition: .3s;
}

#cookies_modal .cookie__floating__buttons__button--decline:hover {
  color: #f44336;
  background: rgba(255, 255, 255, 0.1) !important;
}

#cookies_modal .cookie__floating__buttons__button--accept {
  background: transparent !important;
  color: #D91C49;
  border: unset;
  font-weight: 400;
  transition: .3s;
}

#cookies_modal .cookie__floating__buttons__button--accept:hover {
  color: #4caf50;
  background: rgba(255, 255, 255, 0.1) !important;
}

* {
  font-family: "Inter", sans-serif !important;
}

.text-h1,
.text-h2,
.text-h3,
.text-h4,
.text-h5,
.text-h6 {
  font-family: "Inter", sans-serif !important;
}

html {
  font-size: 15px !important;
  scroll-behavior: smooth;
  scroll-padding-top: 100px;
}

html,
#app,
main {
  background: #070707;
  overflow-x: hidden;
  /* background-image: radial-gradient(circle, rgba(255, 255, 255, 0.1) 1px, rgba(0, 0, 0, 0) 1px);
  background-size: 2px 2px;
  background-repeat: repeat; */
}

/* body {
  background-image: url("/src/assets/img/noice.png");
  background-size: cover;
  opacity: 0.5;
  pointer-events: none;
} */

@media (min-width: 1440px) {
  .v-container {
    max-width: 1400px !important;
  }
}

@media screen and (max-width: 321px) {
  #app {
    zoom: .85;
  }
}
</style>
<style scoped>
#cookies_modal {
  background: #000000;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 15px;
  box-shadow: unset;
}

.cookies_modal_title {
  color: #FFFFFF;
  font-size: 1.1rem;
  font-weight: 500;
  letter-spacing: -0.02rem;
}

.cookies_modal_subtitle {
  color: #737475;
  font-size: 1rem;
  font-weight: 400;
}
</style>